import type { ChangeEvent } from 'react';
import { cn } from '@/lib/cn';

interface SliderProps {
  value: number;
  min: number;
  max: number;
  step?: number;
  onChange: (value: number) => void;
  onCommit?: (value: number) => void;
  label?: string;
  suffix?: string;
  disabled?: boolean;
  className?: string;
}

export function Slider({
  value,
  min,
  max,
  step = 1,
  onChange,
  onCommit,
  label,
  suffix,
  disabled,
  className,
}: SliderProps) {
  return (
    <div className={cn('w-full space-y-2', disabled && 'opacity-50', className)}>
      {(label || suffix) && (
        <div className="flex items-center justify-between text-sm">
          {label && <span className="text-white/70">{label}</span>}
          <span className="text-white tabular-nums font-medium">
            {value}
            {suffix && <span className="text-white/50 ml-1">{suffix}</span>}
          </span>
        </div>
      )}
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        disabled={disabled}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(Number(e.target.value))}
        onMouseUp={(e) => onCommit?.(Number((e.target as HTMLInputElement).value))}
        onTouchEnd={(e) => onCommit?.(Number((e.target as HTMLInputElement).value))}
        className="w-full accent-accent h-2 rounded-full appearance-none bg-bg-elevated cursor-pointer"
      />
    </div>
  );
}
